import { render, staticRenderFns } from "./codeView.vue?vue&type=template&id=a7c2dec4&scoped=true&"
import script from "./codeView.vue?vue&type=script&lang=js&"
export * from "./codeView.vue?vue&type=script&lang=js&"
import style0 from "./codeView.vue?vue&type=style&index=0&id=a7c2dec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c2dec4",
  null
  
)

export default component.exports